export default {
      id: "common__reefer_gt_lg-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#common__reefer_gt_lg",
      toString: function () {
        return this.url;
      }
    }